export const metroStations = [
  { value: 'helwan', ar: 'حلوان', en: 'Helwan', lat: 29.8491, lng: 31.3342 },
  { value: 'ain_helwan', ar: 'عين حلوان', en: 'Ain Helwan', lat: 29.8627, lng: 31.3250 },
  { value: 'helwan_university', ar: 'جامعة حلوان', en: 'Helwan University', lat: 29.8695, lng: 31.3201 },
  { value: 'wadi_hof', ar: 'وادي حوف', en: 'Wadi Hof', lat: 29.8791, lng: 31.3136 },
  { value: 'hadayeq_helwan', ar: 'حدائق حلوان', en: 'Hadayeq Helwan', lat: 29.8970, lng: 31.3045 },
  { value: 'el_maasara', ar: 'المعصرة', en: 'El Maasara', lat: 29.9061, lng: 31.2995 },
  { value: 'tora_el_asmant', ar: 'طرة الأسمنت', en: 'Tora El Asmant', lat: 29.9259, lng: 31.2875 },
  { value: 'kotseika', ar: 'كوتسيكا', en: 'Kotseika', lat: 29.9360, lng: 31.2817 },
  { value: 'tora_el_balad', ar: 'طرة البلد', en: 'Tora El Balad', lat: 29.9469, lng: 31.2729 },
  { value: 'thakanat_el_maadi', ar: 'ثكنات المعادي', en: 'Thakanat El Maadi', lat: 29.9533, lng: 31.2630 },
  { value: 'maadi', ar: 'المعادي', en: 'Maadi', lat: 29.9603, lng: 31.2577 },
  { value: 'hadayeq_el_maadi', ar: 'حدائق المعادي', en: 'Hadayeq El Maadi', lat: 29.9704, lng: 31.2508 },
  { value: 'dar_el_salam', ar: 'دار السلام', en: 'Dar El Salam', lat: 29.9821, lng: 31.2422 },
  { value: 'el_zahraa', ar: 'الزهراء', en: 'El Zahraa', lat: 29.9955, lng: 31.2312 },
  { value: 'mar_girgis', ar: 'مار جرجس', en: 'Mar Girgis', lat: 30.0060, lng: 31.2296 },
  { value: 'el_malek_el_saleh', ar: 'الملك الصالح', en: 'El Malek El Saleh', lat: 30.0178, lng: 31.2312 },
  { value: 'el_sayeda_zeinab', ar: 'السيدة زينب', en: 'El Sayeda Zeinab', lat: 30.0293, lng: 31.2354 },
  { value: 'saad_zaghloul', ar: 'سعد زغلول', en: 'Saad Zaghloul', lat: 30.0371, lng: 31.2384 },
  { value: 'al_sadat', ar: 'السادات', en: 'Al Sadat', lat: 30.0441, lng: 31.2357 },
  { value: 'nasser', ar: 'ناصر', en: 'Nasser', lat: 30.0535, lng: 31.2387 },
  { value: 'orabi', ar: 'عرابي', en: 'Orabi', lat: 30.0567, lng: 31.2420 },
  { value: 'al_shohadaa', ar: 'الشهداء', en: 'Al Shohadaa', lat: 30.0610, lng: 31.2461 },
  { value: 'ghamra', ar: 'غمرة', en: 'Ghamra', lat: 30.0691, lng: 31.2646 },
  { value: 'el_demerdash', ar: 'الدمرداش', en: 'El Demerdash', lat: 30.0773, lng: 31.2778 },
  { value: 'manshiyet_el_sadr', ar: 'منشية الصدر', en: 'Manshiyet El Sadr', lat: 30.0821, lng: 31.2877 },
  { value: 'kobry_el_qobba', ar: 'كوبري القبة', en: 'Kobry El Qobba', lat: 30.0872, lng: 31.2941 },
  { value: 'hammamat_el_qobba', ar: 'حمامات القبة', en: 'Hammamat El Qobba', lat: 30.0912, lng: 31.2989 },
  { value: 'saray_el_qobba', ar: 'سراي القبة', en: 'Saray El Qobba', lat: 30.0971, lng: 31.3046 },
  { value: 'hadayeq_el_zeitoun', ar: 'حدائق الزيتون', en: 'Hadayeq El Zeitoun', lat: 30.1059, lng: 31.3105 },
  { value: 'helmeyet_el_zeitoun', ar: 'حلمية الزيتون', en: 'Helmeyet El Zeitoun', lat: 30.1133, lng: 31.3139 },
  { value: 'el_matariya', ar: 'المطرية', en: 'El Matariya', lat: 30.1213, lng: 31.3137 },
  { value: 'ain_shams', ar: 'عين شمس', en: 'Ain Shams', lat: 30.1310, lng: 31.3191 },
  { value: 'ezbet_el_nakhl', ar: 'عزبة النخل', en: 'Ezbet El Nakhl', lat: 30.1393, lng: 31.3244 },
  { value: 'el_marg', ar: 'المرج', en: 'El Marg', lat: 30.1521, lng: 31.3357 },
  { value: 'el_marg_el_gedida', ar: 'المرج الجديدة', en: 'El Marg El Gedida', lat: 30.1636, lng: 31.3384 },

  // Line 2
  { value: 'shubra_el_kheima', ar: 'شبرا الخيمة', en: 'Shubra El Kheima', lat: 30.1223, lng: 31.2445 },
  { value: 'faculty_of_agriculture', ar: 'كلية الزراعة', en: 'Faculty of Agriculture', lat: 30.1139, lng: 31.2487 },
  { value: 'el_mozalat', ar: 'المظلات', en: 'El Mozalat', lat: 30.1041, lng: 31.2456 },
  { value: 'el_khalafawi', ar: 'الخلفاوي', en: 'El Khalafawi', lat: 30.0979, lng: 31.2454 },
  { value: 'saint_teresa', ar: 'سانت تريزا', en: 'Saint Teresa', lat: 30.0879, lng: 31.2452 },
  { value: 'rod_el_farag', ar: 'روض الفرج', en: 'Rod El Farag', lat: 30.0806, lng: 31.2453 },
  { value: 'mansha', ar: 'مسرة', en: 'Mansha', lat: 30.0709, lng: 31.2450 },
  { value: 'al_ataba', ar: 'العتبة', en: 'Al Ataba', lat: 30.0525, lng: 31.2468 },
  { value: 'mohamed_naguib', ar: 'محمد نجيب', en: 'Mohamed Naguib', lat: 30.0455, lng: 31.2442 },
  { value: 'opera', ar: 'الأوبرا', en: 'Opera', lat: 30.0419, lng: 31.2249 },
  { value: 'dokki', ar: 'الدقي', en: 'Dokki', lat: 30.0384, lng: 31.2122 },
  { value: 'el_bohoos', ar: 'البحوث', en: 'El Bohoos', lat: 30.0358, lng: 31.2002 },
  { value: 'cairo_university_metro', ar: 'جامعة القاهرة', en: 'Cairo University', lat: 30.0260, lng: 31.2012 },
  { value: 'faisal', ar: 'فيصل', en: 'Faisal', lat: 30.0173, lng: 31.2038 },
  { value: 'giza', ar: 'الجيزة', en: 'Giza', lat: 30.0107, lng: 31.2071 },
  { value: 'om_el_masryeen', ar: 'أم المصريين', en: 'Om El Masryeen', lat: 30.0058, lng: 31.2081 },
  { value: 'sakiat_mekki', ar: 'ساقية مكي', en: 'Sakiat Mekki', lat: 29.9955, lng: 31.2087 },
  { value: 'el_monib', ar: 'المنيب', en: 'El Monib', lat: 29.9811, lng: 31.2123 },

  // Line 3
  { value: 'adly_mansour', ar: 'عدلي منصور', en: 'Adly Mansour', lat: 30.1469, lng: 31.4213 },
  { value: 'el_haykestep', ar: 'الهايكستب', en: 'El Haykestep', lat: 30.1438, lng: 31.4047 },
  { value: 'omar_ibn_el_khattab', ar: 'عمر بن الخطاب', en: 'Omar Ibn El Khattab', lat: 30.1403, lng: 31.3943 },
  { value: 'qobaa', ar: 'قباء', en: 'Qobaa', lat: 30.1348, lng: 31.3837 },
  { value: 'hesham_barakat', ar: 'هشام بركات', en: 'Hesham Barakat', lat: 30.1311, lng: 31.3729 },
  { value: 'el_nozha', ar: 'النزهة', en: 'El Nozha', lat: 30.1280, lng: 31.3604 },
  { value: 'nadi_el_shams', ar: 'نادي الشمس', en: 'Nadi El Shams', lat: 30.1227, lng: 31.3439 },
  { value: 'alf_maskan', ar: 'ألف مسكن', en: 'Alf Maskan', lat: 30.1190, lng: 31.3402 },
  { value: 'heliopolis', ar: 'هليوبوليس', en: 'Heliopolis', lat: 30.1084, lng: 31.3382 },
  { value: 'haroun', ar: 'هارون', en: 'Haroun', lat: 30.1015, lng: 31.3329 },
  { value: 'al_ahram', ar: 'الأهرام', en: 'Al Ahram', lat: 30.0918, lng: 31.3263 },
  { value: 'girls_college', ar: 'كلية البنات', en: 'Girls College', lat: 30.0840, lng: 31.3288 },
  { value: 'al_stadium', ar: 'الإستاد', en: 'Al Istadium', lat: 30.0730, lng: 31.3170 },
  { value: 'fairgrounds', ar: 'أرض المعارض', en: 'Fairgrounds', lat: 30.0738, lng: 31.3009 },
  { value: 'abbasiya', ar: 'العباسية', en: 'Abbasiya', lat: 30.0721, lng: 31.2834 },
  { value: 'abdo_pasha', ar: 'عبده باشا', en: 'Abdo Pasha', lat: 30.0648, lng: 31.2747 },
  { value: 'el_geish', ar: 'الجيش', en: 'El Geish', lat: 30.0617, lng: 31.2669 },
  { value: 'bab_el_shaaria', ar: 'باب الشعرية', en: 'Bab El Shaaria', lat: 30.0541, lng: 31.2559 },
  { value: 'maspero', ar: 'ماسبيرو', en: 'Maspero', lat: 30.0559, lng: 31.2321 },
  { value: 'safaa_hegazi', ar: 'صفاء حجازي', en: 'Safaa Hegazi', lat: 30.0623, lng: 31.2249 },
  { value: 'kit_kat', ar: 'الكيت كات', en: 'Kit Kat', lat: 30.0666, lng: 31.2135 },
  { value: 'sudan', ar: 'السودان', en: 'Sudan', lat: 30.0701, lng: 31.2047 },
  { value: 'imbaba', ar: 'إمبابة', en: 'Imbaba', lat: 30.0759, lng: 31.2075 },
  { value: 'el_bohy', ar: 'البوهي', en: 'El Bohy', lat: 30.0821, lng: 31.2109 },
  { value: 'arab_nationalism', ar: 'القومية العربية', en: 'Arab Nationalism', lat: 30.0933, lng: 31.2095 },
  { value: 'ring_road', ar: 'الطريق الدائري', en: 'Ring Road', lat: 30.1027, lng: 31.1998 },
  { value: 'rod_el_farag_axis', ar: 'محور روض الفرج', en: 'Rod El Farag Axis', lat: 30.1118, lng: 31.1842 },
  { value: 'el_tawfikiya', ar: 'التوفيقية', en: 'El Tawfikiya', lat: 30.0651, lng: 31.2024 },
  { value: 'wadi_el_nil', ar: 'وادي النيل', en: 'Wadi El Nil', lat: 30.0575, lng: 31.2001 },
  { value: 'league_of_arab_states', ar: 'جامعة الدول', en: 'League of Arab States', lat: 30.0503, lng: 31.1990 },
  { value: 'bulaq_el_dakrour', ar: 'بولاق الدكرور', en: 'Bulaq El Dakrour', lat: 30.0376, lng: 31.1969 },
];

export const universities = [
  { value: 'ain_shams_uni', ar: 'جامعة عين شمس', en: 'Ain Shams University',
    lat: 30.07694, lng: 31.28500 },

  { value: 'al_azhar_uni', ar: 'جامعة الأزهر', en: 'Al-Azhar University',
    lat: 30.0549, lng: 31.3181 },

  { value: 'helwan_uni', ar: 'جامعة حلوان', en: 'Helwan University',
    lat: 29.8646, lng: 31.3157 },

  { value: 'auc', ar: 'الجامعة الأمريكية بالقاهرة', en: 'American University in Cairo',
    lat: 30.0186, lng: 31.4997 },

  { value: 'guc', ar: 'الجامعة الألمانية بالقاهرة', en: 'German University in Cairo',
    lat: 30.0698, lng: 31.4417 },

  { value: 'bue', ar: 'الجامعة البريطانية في مصر', en: 'British University in Egypt',
    lat: 30.1282, lng: 31.6054 },

  { value: 'cairo_uni', ar: 'جامعة القاهرة', en: 'Cairo University',
    lat: 30.0275, lng: 31.2107 },

  { value: 'future_uni', ar: 'جامعة المستقبل', en: 'Future University in Egypt',
    lat: 29.9896, lng: 31.4829 },

  { value: 'miu', ar: 'جامعة مصر الدولية', en: 'Misr International University',
    lat: 30.1128, lng: 31.6037 },

  { value: 'badr_uni', ar: 'جامعة بدر بالقاهرة', en: 'Badr University in Cairo',
    lat: 30.1450, lng: 31.7157 },

  { value: 'ahram_canadian', ar: 'الجامعة الأهرام الكندية', en: 'Ahram Canadian University',
    lat: 30.0717, lng: 31.0188 },

  { value: 'mti', ar: 'الجامعة الحديثة للتكنولوجيا والمعلومات', en: 'Modern University for Technology and Information',
    lat: 29.9722, lng: 30.9497 },

  { value: 'egyptian_chinese_uni', ar: 'الجامعة المصرية الصينية', en: 'Egyptian Chinese University',
    lat: 30.1910, lng: 31.7337 },

  { value: 'heliopolis_uni', ar: 'جامعة هليوبوليس', en: 'Heliopolis University',
    lat: 30.3128, lng: 31.7425 },

  { value: 'madina_uni', ar: 'جامعة المدينة بالقاهرة', en: 'Al-Madinah University Cairo',
    lat: 30.1776, lng: 31.7462 },

  { value: 'salam_uni', ar: 'جامعة السلام', en: 'Salam University',
    lat: 30.1824, lng: 31.7479 },

  { value: 'russian_uni', ar: 'الجامعة المصرية الروسية', en: 'Russian University in Egypt',
    lat: 30.2245, lng: 31.7421 },

  { value: 'mayo_uni', ar: 'جامعة مايو', en: 'Mayo University',
    lat: 29.8407, lng: 31.3005 },

  { value: 'giu', ar: 'الجامعة الألمانية الدولية', en: 'German International University',
    lat: 30.0169, lng: 31.8665 },

  { value: '6th_october_uni', ar: 'جامعة 6 أكتوبر', en: 'October 6 University',
    lat: 29.9285, lng: 30.9187 },

  { value: 'must', ar: 'جامعة مصر للعلوم والتكنولوجيا', en: 'Misr University for Science and Technology-MUST',
    lat: 29.9727, lng: 30.9449 },

  { value: 'msa', ar: 'جامعة أكتوبر للعلوم الحديثة والآداب', en: 'October University for Modern Sciences and Arts-MSA',
    lat: 29.9969, lng: 30.9707 },

  { value: 'ngu', ar: 'جامعة الجيزة الجديدة', en: 'New Giza University',
    lat: 30.0125, lng: 31.5069 },

  { value: 'nile_uni', ar: 'جامعة النيل الأهلية', en: 'Nile University',
    lat: 30.0105, lng: 30.9867 },

  { value: 'badia_uni', ar: 'جامعة باديا', en: 'Badia University',
    lat: 29.8748, lng: 30.9990 },

  { value: 'innovation_uni', ar: 'جامعة الابتكار', en: 'Innovation University',
    lat: 30.0139, lng: 31.4915 },

  { value: 'obour_uni', ar: 'جامعة العبور للعلوم والتكنولوجيا', en: 'Obour University for Science and Technology',
    lat: 30.2281, lng: 31.4729 },

  { value: 'king_salman_uni', ar: 'جامعة الملك سلمان الدولية فرع القاهرة', en: 'King Salman International University - Cairo Branch',
    lat: 30.0338, lng: 31.2366 },

  { value: 'alamein_uni', ar: 'جامعة العلمين الدولية فرع القاهرة', en: 'Alamein International University - Cairo Branch',
    lat: 30.0419, lng: 31.2357 },

  { value: 'mansoura_new_uni', ar: 'جامعة المنصورة الجديدة فرع القاهرة', en: 'New Mansoura University - Cairo Branch',
    lat: 30.0408, lng: 31.2349 },

  { value: 'helwan_private', ar: 'جامعة حلوان الأهلية', en: 'Helwan University Private',
    lat: 29.8693, lng: 31.3176 },

  { value: 'ain_shams_private', ar: 'جامعة عين شمس الأهلية', en: 'Ain Shams Private University',
    lat: 30.3015, lng: 31.7544 },

  { value: 'french_uni', ar: 'الجامعة الفرنسية في مصر', en: 'French University in Egypt',
    lat: 30.0685, lng: 31.4908 },

  { value: 'cic', ar: 'الجامعة الكندية CIC', en: 'Canadian International College',
    lat: 30.0711, lng: 30.9685 },

  { value: 'esilca', ar: 'جامعة إسلسكا', en: 'ESILCA University',
    lat: 30.0719, lng: 31.0194 },

  { value: 'eue', ar: 'الجامعة الأوروبية في مصر', en: 'European University in Egypt',
    lat: 30.0134, lng: 31.5060 },

  { value: 'elearn_uni', ar: 'الجامعة المصرية للتعلم الإلكتروني الأهلية', en: 'Egyptian E-Learning University',
    lat: 30.0444, lng: 31.2357 },

  { value: 'cairo_sheikh_zayed', ar: 'جامعة القاهرة فرع الشيخ زايد', en: 'Cairo University - Sheikh Zayed Branch',
    lat: 30.0248, lng: 30.9856 },

  { value: 'beni_suef_tech', ar: 'جامعة بني سويف التكنولوجية فرع أكتوبر', en: 'Beni Suef Technological University - October Branch',
    lat: 29.9383, lng: 30.9198 },

  { value: 'eui_giza', ar: 'جامعة مصر للمعلوماتية فرع الجيزة', en: 'Egypt University of Informatics - Giza Branch',
    lat: 30.0730, lng: 31.2800 },
];


export const squares = [
  { value: 'tahrir', ar: 'ميدان التحرير', en: 'Tahrir Square', lat: 30.0444, lng: 31.2357 },
  { value: 'ramses', ar: 'ميدان رمسيس', en: 'Ramses Square', lat: 30.0626, lng: 31.2468 },
  { value: 'talat_harb', ar: 'ميدان طلعت حرب', en: 'Talaat Harb Square', lat: 30.0471, lng: 31.2393 },
  { value: 'ataba', ar: 'ميدان العتبة', en: 'Al Ataba Square', lat: 30.0522, lng: 31.2469 },
  { value: 'giza', ar: 'ميدان الجيزة', en: 'Giza Square', lat: 30.0106, lng: 31.2114 },
  { value: 'lebanon', ar: 'ميدان لبنان', en: 'Lebanon Square', lat: 30.0617, lng: 31.1981 },
  { value: 'mostafa_mahmoud', ar: 'ميدان مصطفى محمود', en: 'Mostafa Mahmoud Square', lat: 30.0525, lng: 31.2011 },
  { value: 'sphinx', ar: 'ميدان سفنكس', en: 'Sphinx Square', lat: 30.0575, lng: 31.2083 },
  { value: 'hussein', ar: 'ميدان الحسين', en: 'Al Hussein Square', lat: 30.0478, lng: 31.2625 },
  { value: 'abbasiya', ar: 'ميدان العباسية', en: 'Abbasiya Square', lat: 30.0633, lng: 31.2811 },
  { value: 'sayeda_zeinab', ar: 'ميدان السيدة زينب', en: 'Sayeda Zeinab Square', lat: 30.0305, lng: 31.2403 },
  { value: 'roxy', ar: 'ميدان روكسي', en: 'Roxy Square', lat: 30.0919, lng: 31.3105 },
  { value: 'gelaa', ar: 'ميدان الجلاء', en: 'Gelaa Square', lat: 30.0396, lng: 31.2185 },
  { value: 'remaya', ar: 'ميدان الرماية', en: 'Remaya Square', lat: 29.9936, lng: 31.1278 },
  { value: 'kitkat', ar: 'ميدان الكيت كات', en: 'Kit Kat Square', lat: 30.0645, lng: 31.2132 },
  { value: 'masaha', ar: 'ميدان المساحة', en: 'Al Masaha Square', lat: 30.0361, lng: 31.2111 },
];